import { v4 as uuidv4 } from 'uuid';
import type { Incident205aContact } from 'components/IAP/hooks/incident205aContactHooks';
import type { Ics205aDraftContact } from './types';

export const contactKey = (contact: { contact_id: string }) =>
  contact.contact_id;

export const cloneContacts = (
  contacts: Ics205aDraftContact[]
): Ics205aDraftContact[] => contacts.map((row) => ({ ...row }));

export const toDraftContact = (
  contact: Incident205aContact
): Ics205aDraftContact => ({
  contact_id: contact.contact_id,
  id: contact.id,
  assignment: contact.assignment ?? '',
  name: contact.name ?? '',
  cell_phone: contact.cell_phone ?? '',
  radio_frequency: contact.radio_frequency ?? '',
  other: contact.other ?? '',
  sort_order: contact.sort_order ?? 0,
  archived: !!contact.archived,
  isNew: false,
});

export const serializeContactsDraft = (
  contacts: Ics205aDraftContact[]
): string =>
  JSON.stringify(
    contacts.map((row) => ({
      contact_id: row.contact_id,
      assignment: row.assignment,
      name: row.name,
      cell_phone: row.cell_phone,
      radio_frequency: row.radio_frequency,
      other: row.other,
      sort_order: row.sort_order,
      archived: row.archived,
    }))
  );

export const contactChanged = (
  draft: Ics205aDraftContact,
  server: Incident205aContact | undefined
): boolean => {
  if (!server) return true;
  return (
    (draft.assignment ?? '') !== (server.assignment ?? '') ||
    (draft.name ?? '') !== (server.name ?? '') ||
    (draft.cell_phone ?? '') !== (server.cell_phone ?? '') ||
    (draft.radio_frequency ?? '') !== (server.radio_frequency ?? '') ||
    (draft.other ?? '') !== (server.other ?? '') ||
    !!draft.archived !== !!server.archived ||
    (draft.sort_order ?? 0) !== (server.sort_order ?? 0)
  );
};

export const createTempContact = (
  sort_order: number,
  seed?: Partial<Ics205aDraftContact>
): Ics205aDraftContact => ({
  contact_id: `temp-${uuidv4()}`,
  assignment: seed?.assignment ?? '',
  name: seed?.name ?? '',
  cell_phone: seed?.cell_phone ?? '',
  radio_frequency: seed?.radio_frequency ?? '',
  other: seed?.other ?? '',
  sort_order,
  archived: false,
  isNew: true,
});
